import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Tag, message } from 'antd';
import api from '../../../utils/api';

const { Title, Paragraph } = Typography;

const CampaignPerformance = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const columns = [
    { title: 'Campaign', dataIndex: 'name', key: 'name' },
    { title: 'Client', dataIndex: 'client', key: 'client' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: s => <Tag color={s === 'active' ? 'green' : s === 'paused' ? 'orange' : 'red'}>{s}</Tag> },
    { title: 'Impressions', dataIndex: 'impressions', key: 'impressions', render: v => v.toLocaleString() },
    { title: 'Miles', dataIndex: 'miles', key: 'miles', render: v => Number(v ?? 0).toFixed(2) },
    { 
      title: 'Impr/Mile', 
      key: 'impressions_per_mile', 
      render: (_, record) => {
        const miles = Number(record.miles ?? 0);
        const impressions = Number(record.impressions ?? 0);
        if (miles === 0) return '-';
        return (impressions / miles).toFixed(0);
      }
    },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', render: v => v.toLocaleString() },
    { title: 'CTR', dataIndex: 'ctr', key: 'ctr', render: v => `${v}%` },
    { title: 'Conversions', dataIndex: 'conversions', key: 'conversions', render: v => v.toLocaleString() },
    { title: 'CPA', dataIndex: 'cpa', key: 'cpa', render: v => `$${v}` },
  ];

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const resp = await api.get('/analytics/campaign-performance?limit=1000');
        const items = Array.isArray(resp?.items) ? resp.items : [];
        setRows(items.map(it => ({
          key: it.campaign_id,
          name: it.name,
          client: it.client,
          status: it.status,
          impressions: it.impressions,
          miles: it.miles,
          clicks: it.clicks,
          ctr: it.ctr,
          conversions: it.conversions,
          cpa: it.cpa,
        })));
      } catch (e) {
        message.error(e.message || 'Failed to load performance');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Admin' }, { title: 'Analytics' }, { title: 'Campaign Performance' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Campaign Performance</Title>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Placeholder campaign KPIs. Replace with analytics API.</Paragraph>
        <Table rowKey="name" columns={columns} dataSource={rows} loading={loading} pagination={{ pageSize: 10 }} />
      </Card>
    </div>
  );
};

export default CampaignPerformance;
